<template>
<div>
  <div class="w-100" id="filter" app-call="app.products.navigation">
    <div class=" align-items-center d-flex">
      <div class="container">
        <div class="row">
          <div class="col-xl-12">
            <div class="row mb-36">
              <!-- <div class="align-items-center d-flex">
                            <button class="btn" @click="toggleShowSearchText()"><i class="fal fa-search fz-24"></i></button>
              </div>-->
              <div class="align-items-center d-flex col-xl-7 mx-auto">
                <div class="input-group color-dark-gray px-2 animated fadeIn display-inline-block">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Search Products"
                    aria-label="Search Products"
                    v-model="searchString"
                  />
                  <div class="input-group-append">
                    <button class="btn btn-nelson-blue" type="button" @click="searchPosts">
                      <i class="fal fa-search"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-if="loadingCategories == false">
              <div class="col">
                <div class="d-block d-md-flex justify-content-between align-items-center">
                  <p class="fz-16 mb-0">Let us help you find the perfect scoreboard. Select all that apply.</p>
                  <button type="button" class="btn btn-orange-outline mb-2" aria-label="Close" @click="resetTerms()">
                    <span aria-hidden="true"><i class="fa fa-close mr-2"></i> Reset Categories</span>
                  </button>
                </div>
                <table class="table table-striped filter-navigation" v-if="showTermsTable">
                  <tbody>
                  <tr class="" v-for="category_group in category_groups" :key="category_group.id">
                    <td class="fz-16" v-if="(category_group.categories.length>0)">{{category_group.title}}</td>
                    <td v-if="(category_group.categories.length>0)" class="">
                    <div class="form-check form-check-inline" v-for="category in category_group.categories" :key="category.ID">
                      <input class="form-check-input" type="checkbox" :id="category" :name="category" :value="category" v-model="checkedTerms" @click="toggleTerm(category)" v-if="terms[category]">
                      <label class="form-check-label"  :for="category" v-if="terms[category]">{{terms[category].name}}</label>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div>
    <div class="container"></div>
  </div>
  <div class="sr-alert sr-only" role="alert" v-html="srAlert"></div>
</div>
</template>
<script>
const axios = require('axios');
export default {
  created() {
    this.getCategories();
    this.setTerms();
    // this.updateCategoryGroups();
  },
  mounted() {
    // console.log('products mounted');
  },
  methods: {
    setTerm: function(slug, heading) {
      app.products.productsByCategoryApp.setTerm(slug, heading);
    },
    toggleTerm: function(slug) {
      app.products.productsByCategoryApp.toggleTerm(slug);
    },
    resetTerms: function() {
			this.$set(this, 'checkedTerms', []);
      app.products.productsByCategoryApp.resetTerms();
    },
    searchPosts: function() {
      this.$set(this, 'checkedTerms', []);
      app.products.productsByCategoryApp.searchPosts(this.searchString);
    },
    toggleShowSearchText: function() {
      this.showSearchText = !this.showSearchText;
    },
    togglefiltersOpen: function() {
        this.filtersOpen = !this.filtersOpen;
    },
    getCategoriesRequest(parent = 'none'){
      return axios.get(`${this.api.prefix}categories`);
    },
    getCategories(parent = 'none'){
			this.$set(this, 'loadingCategories', true);
				this.getCategoriesRequest('none')
				.then(categories => {
					if(categories.data.length == 0 ){
						this.showLoadMore = false;
						if(page==0){
							this.showNoResults = true;
						}
					} else{
						this.$set(this, 'loadingCategories', false);
						this.delayedCategoryInsert(this.categories, categories.data);
						if(categories.data.length < take){
							this.showLoadMore = false;
						}
					}
				}).catch(err => {
					this.$set(this, 'loadingCategories', false);
				});
    },
    setTerms(){
			axios.get(`${this.api.prefix}terms/`).then(response => {
				response.data.forEach(term => {
					this.$set(this.terms, term.slug, term);
        });
        this.$set(this, 'loadingCategories', false);
        this.$set(this, 'showTermsTable', true);
			});
		},
    delayedCategoryInsert(subject, items){
			const [item, ...rest] = items;
			subject.push(item);
			if (rest.length > 0){
				setTimeout(() => {
					this.delayedCategoryInsert(subject, rest);
				}, 20);
			}
		},
  },
  data: {
    showSearchText: false,
    searchString: "",
    filtersOpen: false,
    srAlert: "",
    showTermsTable: false,
    api: {
				prefix: '/wp-json/usdp/v1/',
				posts: 'products/'
			},
    categories: [],
    category_groups: [
      { "id": 1, "title":"Select type of environment:", "categories":['indoor-sports-scoreboards','outdoor']},
      { "id": 2, "title":"Select type of sport:", "categories":['football','basketball', 'baseball', 'soccer', 'lacrosse', 'hockey', 'tennis', 'track', 'softball', 'field-hockey','volleyball', 'cricket', 'wrestling']},
      { "id": 3, "title":"Accessories & Add-Ons:", "categories":['scoreboard-controls','scoreboard-accessories-add-ons']},
      { "id": 4, "title":"Other:", "categories":[]},
    ],
    loadingCategories: true,
    checkedTerms: [],
    terms: {},
  }
};
</script>
